import slice from './slice'

export * as selectors from './selectors'

export { initialState } from './data'
export const { reducer } = slice
